import { render, staticRenderFns } from "./homeworkexam.vue?vue&type=template&id=494313c7&scoped=true"
import script from "./homeworkexam.vue?vue&type=script&lang=js"
export * from "./homeworkexam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494313c7",
  null
  
)

export default component.exports